module.exports = __webpack_public_path__ + "static/media/Equity.3a67b6c5.png";